import { baseApi } from './BaseService';
import {
  GetMLTagByIdResponse,
  UpdateMLTagByIdRequest,
} from '../responseTypes/mediaLibraryTags';

const baseUrl = '/filer/admin/tags';

export const mediaLibraryTagsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAllMlTags: build.query({
      query: () => ({
        url: `${baseUrl}`,
      }),
    }),
    getMlTagById: build.query<GetMLTagByIdResponse, { tagId: string }>({
      query: ({ tagId }) => ({
        url: `${baseUrl}/${tagId}`,
      }),
      providesTags: ['MLTag'],
    }),
    createMlTag: build.mutation<GetMLTagByIdResponse, UpdateMLTagByIdRequest>({
      query: (data) => ({
        url: `${baseUrl}`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['MLTag'],
    }),
    updateMlTagById: build.mutation<
      GetMLTagByIdResponse,
      { tagId: string; data: UpdateMLTagByIdRequest }
    >({
      query: ({ tagId, data }) => ({
        url: `${baseUrl}/${tagId}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['MLTag'],
    }),
    deleteMlTagById: build.mutation<string, string>({
      query: (tagId) => ({
        url: `${baseUrl}/${tagId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['MLTag'],
    }),
  }),
});
